import { render } from "./TheMessagesDropdown.vue?vue&type=template&id=3af6a393&scoped=true"
import script from "./TheMessagesDropdown.vue?vue&type=script&lang=js"
export * from "./TheMessagesDropdown.vue?vue&type=script&lang=js"

import "../css/adminlte.css?vue&type=style&index=0&id=3af6a393&lang=css&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af6a393"]])

export default __exports__